import type { Theme } from '@emotion/react';

export const getLinkColor = (theme: Theme) =>
  theme.stellenportal?.linkStyle?.color || theme.eclipseTier2Color.text.brand.default;
